__turbopack_context__.v({
  "button": "PlasmicPricingProducts-module__z_J72q__button",
  "button2": "PlasmicPricingProducts-module__z_J72q__button2",
  "button3": "PlasmicPricingProducts-module__z_J72q__button3",
  "button4": "PlasmicPricingProducts-module__z_J72q__button4",
  "button5": "PlasmicPricingProducts-module__z_J72q__button5",
  "button6": "PlasmicPricingProducts-module__z_J72q__button6",
  "button7": "PlasmicPricingProducts-module__z_J72q__button7",
  "button8": "PlasmicPricingProducts-module__z_J72q__button8",
  "button9": "PlasmicPricingProducts-module__z_J72q__button9",
  "col": "PlasmicPricingProducts-module__z_J72q__col",
  "col2": "PlasmicPricingProducts-module__z_J72q__col2",
  "col3": "PlasmicPricingProducts-module__z_J72q__col3",
  "col4": "PlasmicPricingProducts-module__z_J72q__col4",
  "containter": "PlasmicPricingProducts-module__z_J72q__containter",
  "containter2": "PlasmicPricingProducts-module__z_J72q__containter2",
  "contents": "PlasmicPricingProducts-module__z_J72q__contents",
  "contents2": "PlasmicPricingProducts-module__z_J72q__contents2",
  "contentsItem4": "PlasmicPricingProducts-module__z_J72q__contentsItem4",
  "contentsItem5": "PlasmicPricingProducts-module__z_J72q__contentsItem5",
  "contentsItem6": "PlasmicPricingProducts-module__z_J72q__contentsItem6",
  "desktop": "PlasmicPricingProducts-module__z_J72q__desktop",
  "freeBox__tcxr4": "PlasmicPricingProducts-module__z_J72q__freeBox__tcxr4",
  "freeBox__veWWz": "PlasmicPricingProducts-module__z_J72q__freeBox__veWWz",
  "header": "PlasmicPricingProducts-module__z_J72q__header",
  "header10": "PlasmicPricingProducts-module__z_J72q__header10",
  "header2": "PlasmicPricingProducts-module__z_J72q__header2",
  "header3": "PlasmicPricingProducts-module__z_J72q__header3",
  "header4": "PlasmicPricingProducts-module__z_J72q__header4",
  "header5": "PlasmicPricingProducts-module__z_J72q__header5",
  "header6": "PlasmicPricingProducts-module__z_J72q__header6",
  "header7": "PlasmicPricingProducts-module__z_J72q__header7",
  "header8": "PlasmicPricingProducts-module__z_J72q__header8",
  "header9": "PlasmicPricingProducts-module__z_J72q__header9",
  "icon4": "PlasmicPricingProducts-module__z_J72q__icon4",
  "icon5": "PlasmicPricingProducts-module__z_J72q__icon5",
  "icon6": "PlasmicPricingProducts-module__z_J72q__icon6",
  "img___8ARSa": "PlasmicPricingProducts-module__z_J72q__img___8ARSa",
  "img__da3Ct": "PlasmicPricingProducts-module__z_J72q__img__da3Ct",
  "img__f65Y1": "PlasmicPricingProducts-module__z_J72q__img__f65Y1",
  "img__tmG6": "PlasmicPricingProducts-module__z_J72q__img__tmG6",
  "img__vy6": "PlasmicPricingProducts-module__z_J72q__img__vy6",
  "img__zfy3B": "PlasmicPricingProducts-module__z_J72q__img__zfy3B",
  "left": "PlasmicPricingProducts-module__z_J72q__left",
  "listItem___7PdvZ": "PlasmicPricingProducts-module__z_J72q__listItem___7PdvZ",
  "listItem__mNt5F": "PlasmicPricingProducts-module__z_J72q__listItem__mNt5F",
  "listItem__ohtRr": "PlasmicPricingProducts-module__z_J72q__listItem__ohtRr",
  "logo": "PlasmicPricingProducts-module__z_J72q__logo",
  "logo2": "PlasmicPricingProducts-module__z_J72q__logo2",
  "logo3": "PlasmicPricingProducts-module__z_J72q__logo3",
  "logo4": "PlasmicPricingProducts-module__z_J72q__logo4",
  "logo5": "PlasmicPricingProducts-module__z_J72q__logo5",
  "logo6": "PlasmicPricingProducts-module__z_J72q__logo6",
  "mask": "PlasmicPricingProducts-module__z_J72q__mask",
  "mobile": "PlasmicPricingProducts-module__z_J72q__mobile",
  "pricing": "PlasmicPricingProducts-module__z_J72q__pricing",
  "pricing2": "PlasmicPricingProducts-module__z_J72q__pricing2",
  "product": "PlasmicPricingProducts-module__z_J72q__product",
  "product2": "PlasmicPricingProducts-module__z_J72q__product2",
  "product3": "PlasmicPricingProducts-module__z_J72q__product3",
  "product4": "PlasmicPricingProducts-module__z_J72q__product4",
  "product5": "PlasmicPricingProducts-module__z_J72q__product5",
  "product6": "PlasmicPricingProducts-module__z_J72q__product6",
  "products": "PlasmicPricingProducts-module__z_J72q__products",
  "program": "PlasmicPricingProducts-module__z_J72q__program",
  "program2": "PlasmicPricingProducts-module__z_J72q__program2",
  "program3": "PlasmicPricingProducts-module__z_J72q__program3",
  "program4": "PlasmicPricingProducts-module__z_J72q__program4",
  "program5": "PlasmicPricingProducts-module__z_J72q__program5",
  "program6": "PlasmicPricingProducts-module__z_J72q__program6",
  "rawNull": "PlasmicPricingProducts-module__z_J72q__rawNull",
  "right": "PlasmicPricingProducts-module__z_J72q__right",
  "section": "PlasmicPricingProducts-module__z_J72q__section",
  "section2": "PlasmicPricingProducts-module__z_J72q__section2",
  "svg___2TEqz": "PlasmicPricingProducts-module__z_J72q__svg___2TEqz",
  "svg___3Lmv6": "PlasmicPricingProducts-module__z_J72q__svg___3Lmv6",
  "svg___6FbJw": "PlasmicPricingProducts-module__z_J72q__svg___6FbJw",
  "svg___6M72F": "PlasmicPricingProducts-module__z_J72q__svg___6M72F",
  "svg__a1CbM": "PlasmicPricingProducts-module__z_J72q__svg__a1CbM",
  "svg__asJ0A": "PlasmicPricingProducts-module__z_J72q__svg__asJ0A",
  "svg__cNqz": "PlasmicPricingProducts-module__z_J72q__svg__cNqz",
  "svg__czkkb": "PlasmicPricingProducts-module__z_J72q__svg__czkkb",
  "svg__dnVk7": "PlasmicPricingProducts-module__z_J72q__svg__dnVk7",
  "svg__g5Eb": "PlasmicPricingProducts-module__z_J72q__svg__g5Eb",
  "svg__h3MGl": "PlasmicPricingProducts-module__z_J72q__svg__h3MGl",
  "svg__iOeUl": "PlasmicPricingProducts-module__z_J72q__svg__iOeUl",
  "svg__jHyPi": "PlasmicPricingProducts-module__z_J72q__svg__jHyPi",
  "svg__k0DKq": "PlasmicPricingProducts-module__z_J72q__svg__k0DKq",
  "svg__nvexn": "PlasmicPricingProducts-module__z_J72q__svg__nvexn",
  "svg__pe3NH": "PlasmicPricingProducts-module__z_J72q__svg__pe3NH",
  "svg__qemWz": "PlasmicPricingProducts-module__z_J72q__svg__qemWz",
  "svg__r5PVn": "PlasmicPricingProducts-module__z_J72q__svg__r5PVn",
  "svg__rjdC": "PlasmicPricingProducts-module__z_J72q__svg__rjdC",
  "svg__uVbLw": "PlasmicPricingProducts-module__z_J72q__svg__uVbLw",
  "svg__ueg3C": "PlasmicPricingProducts-module__z_J72q__svg__ueg3C",
  "svg__whkUj": "PlasmicPricingProducts-module__z_J72q__svg__whkUj",
  "tableTbody__qZxhx": "PlasmicPricingProducts-module__z_J72q__tableTbody__qZxhx",
  "tableTbody__qqTpi": "PlasmicPricingProducts-module__z_J72q__tableTbody__qqTpi",
  "tableTd__b3Poj": "PlasmicPricingProducts-module__z_J72q__tableTd__b3Poj",
  "tableTd__d4T5X": "PlasmicPricingProducts-module__z_J72q__tableTd__d4T5X",
  "tableTd__hsEdp": "PlasmicPricingProducts-module__z_J72q__tableTd__hsEdp",
  "tableTd__scnIo": "PlasmicPricingProducts-module__z_J72q__tableTd__scnIo",
  "tableTh___0L6D5": "PlasmicPricingProducts-module__z_J72q__tableTh___0L6D5",
  "tableTh__lhGq9": "PlasmicPricingProducts-module__z_J72q__tableTh__lhGq9",
  "tableTh__rd57I": "PlasmicPricingProducts-module__z_J72q__tableTh__rd57I",
  "tableTh__s5Gcu": "PlasmicPricingProducts-module__z_J72q__tableTh__s5Gcu",
  "tableThead__aXoDt": "PlasmicPricingProducts-module__z_J72q__tableThead__aXoDt",
  "tableThead__sLf9M": "PlasmicPricingProducts-module__z_J72q__tableThead__sLf9M",
  "tableTr__igvdn": "PlasmicPricingProducts-module__z_J72q__tableTr__igvdn",
  "tableTr__mWgJi": "PlasmicPricingProducts-module__z_J72q__tableTr__mWgJi",
  "tableTr__slRZ": "PlasmicPricingProducts-module__z_J72q__tableTr__slRZ",
  "tableTr__x4YdP": "PlasmicPricingProducts-module__z_J72q__tableTr__x4YdP",
  "table__byJvZ": "PlasmicPricingProducts-module__z_J72q__table__byJvZ",
  "table__uwwGx": "PlasmicPricingProducts-module__z_J72q__table__uwwGx",
  "tagline": "PlasmicPricingProducts-module__z_J72q__tagline",
  "tagline11": "PlasmicPricingProducts-module__z_J72q__tagline11",
  "tagline12": "PlasmicPricingProducts-module__z_J72q__tagline12",
  "tagline13": "PlasmicPricingProducts-module__z_J72q__tagline13",
  "tagline15": "PlasmicPricingProducts-module__z_J72q__tagline15",
  "tagline3": "PlasmicPricingProducts-module__z_J72q__tagline3",
  "tagline4": "PlasmicPricingProducts-module__z_J72q__tagline4",
  "tagline5": "PlasmicPricingProducts-module__z_J72q__tagline5",
  "tagline7": "PlasmicPricingProducts-module__z_J72q__tagline7",
  "tagline9": "PlasmicPricingProducts-module__z_J72q__tagline9",
  "text": "PlasmicPricingProducts-module__z_J72q__text",
  "text19": "PlasmicPricingProducts-module__z_J72q__text19",
  "text2": "PlasmicPricingProducts-module__z_J72q__text2",
  "text20": "PlasmicPricingProducts-module__z_J72q__text20",
  "text21": "PlasmicPricingProducts-module__z_J72q__text21",
  "text3": "PlasmicPricingProducts-module__z_J72q__text3",
  "text32": "PlasmicPricingProducts-module__z_J72q__text32",
  "text33": "PlasmicPricingProducts-module__z_J72q__text33",
  "text4": "PlasmicPricingProducts-module__z_J72q__text4",
  "text___0IB3": "PlasmicPricingProducts-module__z_J72q__text___0IB3",
  "text___3BaMs": "PlasmicPricingProducts-module__z_J72q__text___3BaMs",
  "text___5QyFy": "PlasmicPricingProducts-module__z_J72q__text___5QyFy",
  "text___6LvqN": "PlasmicPricingProducts-module__z_J72q__text___6LvqN",
  "text___6TDkY": "PlasmicPricingProducts-module__z_J72q__text___6TDkY",
  "text___98QX2": "PlasmicPricingProducts-module__z_J72q__text___98QX2",
  "text__bqhor": "PlasmicPricingProducts-module__z_J72q__text__bqhor",
  "text__bxXug": "PlasmicPricingProducts-module__z_J72q__text__bxXug",
  "text__fKpaa": "PlasmicPricingProducts-module__z_J72q__text__fKpaa",
  "text__ij7Rr": "PlasmicPricingProducts-module__z_J72q__text__ij7Rr",
  "text__jEqOg": "PlasmicPricingProducts-module__z_J72q__text__jEqOg",
  "text__lg13W": "PlasmicPricingProducts-module__z_J72q__text__lg13W",
  "text__mn31T": "PlasmicPricingProducts-module__z_J72q__text__mn31T",
  "text__pxAwV": "PlasmicPricingProducts-module__z_J72q__text__pxAwV",
  "text__s8C6M": "PlasmicPricingProducts-module__z_J72q__text__s8C6M",
  "text__xnCu9": "PlasmicPricingProducts-module__z_J72q__text__xnCu9",
  "title10": "PlasmicPricingProducts-module__z_J72q__title10",
  "title11": "PlasmicPricingProducts-module__z_J72q__title11",
  "title12": "PlasmicPricingProducts-module__z_J72q__title12",
  "title13": "PlasmicPricingProducts-module__z_J72q__title13",
  "title14": "PlasmicPricingProducts-module__z_J72q__title14",
  "title15": "PlasmicPricingProducts-module__z_J72q__title15",
  "title16": "PlasmicPricingProducts-module__z_J72q__title16",
  "title17": "PlasmicPricingProducts-module__z_J72q__title17",
  "title2": "PlasmicPricingProducts-module__z_J72q__title2",
  "title3": "PlasmicPricingProducts-module__z_J72q__title3",
  "title4": "PlasmicPricingProducts-module__z_J72q__title4",
  "title5": "PlasmicPricingProducts-module__z_J72q__title5",
  "title6": "PlasmicPricingProducts-module__z_J72q__title6",
  "title7": "PlasmicPricingProducts-module__z_J72q__title7",
  "title8": "PlasmicPricingProducts-module__z_J72q__title8",
  "title9": "PlasmicPricingProducts-module__z_J72q__title9",
  "top2": "PlasmicPricingProducts-module__z_J72q__top2",
  "top3": "PlasmicPricingProducts-module__z_J72q__top3",
  "top4": "PlasmicPricingProducts-module__z_J72q__top4",
  "top5": "PlasmicPricingProducts-module__z_J72q__top5",
  "top6": "PlasmicPricingProducts-module__z_J72q__top6",
  "top7": "PlasmicPricingProducts-module__z_J72q__top7",
});
